import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	TestabilityRegistry,
	ChangeDetectorRef
} from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { RegistrationRequest } from "src/app/models/dmv/registration.request";
import { DmvRegistration } from "src/app/models/dmv/dmvRegistration";
import { TagCatalog } from "src/app/models/dmv/tagCatalog";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { AppUtil } from "../../../utils/app.util";
import { Registrations } from "src/app/models/dmv/registrations";
import {
	FormBuilder,
	FormControl,
	FormGroup,
	Validators
} from "@angular/forms";
@Component({
	selector: "dmv-search-results",
	templateUrl: "./search-results.component.html",
	styleUrls: ["./search-results.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchResultsComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		private formBuilder: FormBuilder,
		public dmvStoreService: DMVStoreService,
		private cd: ChangeDetectorRef
	) {}
	public errorMessage: string = "";
	public currentPage: number = 1;
	public pageNumbers: Array<number>;
	public tagCatalog: TagCatalog;
	public isloading: boolean = false;
	public agencyConfig: AgencyDmvConfigResponse;
	public totalPage;
	public qrCode: boolean = false;
	public isExternalLint: boolean = false;
	public registrations: Registrations = [];
	public searchRegistrationForm: FormGroup;
	public isPrivacy: boolean = false;
	public isPrivacyOpen: boolean = false;
	ngOnInit() {
		this.registrations = [];
		if (
			this.globalService.params &&
			this.globalService.params.token &&
			this.globalService.getDirectURLCall()
		) {
			this.isExternalLint = true;
			this.globalService.params = null;
			this.globalService.setDirectURLCall(false);
			window["externallink"] = {};
		}
		if (window["qrDetail"] && this.globalService.getQrCall()) {
			this.qrCode = true;
		}
		if (
			(window["qrDetail"] && this.globalService.getQrCall()) ||
			this.isExternalLint
		) {
			this.cd.markForCheck();
			this.searchRegistrationForm = this.formBuilder.group({});
			this.searchRegistrationForm.addControl(
				"privacy",
				new FormControl(
					this.dmvStoreService.isPrivacyCheck,
					Validators.required
				)
			);
		}
		this.globalService.setQrCall(false);
		AppUtil.log("SearchResultsComponent ngOnInit() ==>");
		this.currentPage = this.dmvStoreService.targetPageNumber;
		this.dmvStoreService.registrationData$.subscribe(
			registrationResponse => {
				AppUtil.log(
					"SearchResultsComponent registrationData$.subscrib ==>",
					registrationResponse
				);
				if (registrationResponse) {
					this.isloading = false;
					this.pageNumbers = [];
					this.totalPage = registrationResponse.totalPageCount;
					this.registrations = [...registrationResponse.registrations];
					for (let i = 0; i < this.totalPage; i++) {
						this.pageNumbers.push(i + 1);
					}
					this.cd.markForCheck();
				}
			},
			error => {
				AppUtil.log(
					"SearchResultsComponent registrationData$.subscrib ==> error",
					error
				);
				if (
					error.name === "HttpErrorResponse" ||
					error.name === "TimeoutError" ||
					(error["status"] && error["status"] !== 200)
				) {
					this.errorMessage = this.dmvStoreService.agencyConfig.agencyDmvConfig.systemFailureText;
					this.isloading = false;
					window.scrollTo(0, 0);
					this.cd.markForCheck();
				}
			}
		);

		this.dmvStoreService.tagCatalogData$.subscribe(tagCatalogResponse => {
			if (tagCatalogResponse) {
				this.tagCatalog = tagCatalogResponse.tagCatalog;
			}
		});
		this.dmvStoreService.agencyConfig$.subscribe(agencyConfig => {
			if (agencyConfig) {
				this.agencyConfig = agencyConfig;
			}
		});
	}
	public paginationBack() {
		AppUtil.log("SearchResultsComponent paginationBack() ==>");
		if (this.currentPage > 1) {
			this.currentPage = this.currentPage - 1;

			this.getRegistrationByPagination(this.currentPage);
		}
	}
	public paginationNext() {
		AppUtil.log("SearchResultsComponent paginationNext() ==>");
		if (this.currentPage < this.totalPage) {
			this.currentPage = this.currentPage + 1;

			this.getRegistrationByPagination(this.currentPage);
		}
	}
	public get f() {
		return this.searchRegistrationForm.controls;
	}
	public pagination(page) {
		AppUtil.log("SearchResultsComponent paginationNext() ==> page: ", page);
		this.currentPage = page;
		this.getRegistrationByPagination(this.currentPage);
	}

	private getRegistrationByPagination(pageNumber: number) {
		AppUtil.log(
			"SearchResultsComponent getRegistrationByPagination() ==> pageNumber: ",
			pageNumber
		);
		const registrationRequest: RegistrationRequest = this.dmvStoreService
			.registrationSearchRequest;
		this.dmvStoreService.targetPageNumber = pageNumber;
		registrationRequest.targetPageNumber = pageNumber;
		this.isloading = true;
		registrationRequest.qrCode = this.qrCode;
		this.dmvStoreService.findRegistrations(registrationRequest);
	}
	public isInCart(registration) {
		AppUtil.log(
			"SearchResultsComponent isInCart() ==> registration: ",
			registration
		);
		let val = false;
		if (
			this.dmvStoreService.registrationsInCart &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations
		) {
			this.dmvStoreService.registrationsInCart.dmvRegistrations.forEach(
				registrationinCart => {
					if (
						registrationinCart.registration.registrationID ===
						registration.registrationID
					) {
						val = true;
					}
				}
			);
		}
		return val;
	}
	public openPrivacy() {
		this.isPrivacyOpen = true;
	}
	public closePrivacy() {
		this.isPrivacyOpen = false;
	}
	public removeInCart(registration) {
		AppUtil.log(
			"SearchResultsComponent removeInCart() ==> registration: ",
			registration
		);
		//registration.isInCart = false;
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from === "add-another"
		) {
			const index = this.dmvStoreService.registrationsInCart.dmvRegistrations.findIndex(
				function(dmvRegistrations) {
					return (
						dmvRegistrations.registration.registrationID ===
						registration.registrationID
					);
				}
			);

			if (index >= this.dmvStoreService.routeFrom.orderNumber) {
				this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.filter(
					function(item) {
						return (
							item.registration.registrationID !== registration.registrationID
						);
					}
				);
				this.dmvStoreService.registrationsInCart.selectedRegistrations = this.dmvStoreService.registrationsInCart.selectedRegistrations.filter(
					function(item) {
						return item.registrationID !== registration.registrationID;
					}
				);
			}
		} else {
			this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.filter(
				function(item) {
					return (
						item.registration.registrationID !== registration.registrationID
					);
				}
			);
			this.dmvStoreService.registrationsInCart.selectedRegistrations = this.dmvStoreService.registrationsInCart.selectedRegistrations.filter(
				function(item) {
					return item.registrationID !== registration.registrationID;
				}
			);
		}
	}
	public addInCart(registration) {
		AppUtil.log(
			"SearchResultsComponent addInCart() ==> registration: ",
			registration
		);
		//	registration.isInCart = true;
		const dmvRegistration: DmvRegistration = new DmvRegistration();
		dmvRegistration.registration = Object.assign({}, registration);
		if (
			(this.dmvStoreService.registrationsInCart &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations ===
					undefined) ||
			(this.dmvStoreService.registrationsInCart &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations &&
				this.dmvStoreService.registrationsInCart.dmvRegistrations.indexOf(
					registration
				) === -1)
		) {
			let renewalCost = 0;
			if (
				registration.availableRenewalOptions &&
				registration.availableRenewalOptions.length > 0
			) {
				renewalCost = registration.availableRenewalOptions[0].cost;
				dmvRegistration.selectedRenewalOption = 1;
			} else if (registration.allowPlateChange) {
				dmvRegistration.selectedRenewalOption = 999;
			}

			let costAmount = 0;
			if (renewalCost) {
				costAmount = costAmount + renewalCost;
			}
			let plateStyleCost = 0;

			let otherFees = 0;
			if (registration.dmvFees && registration.dmvFees.length > 0) {
				registration.dmvFees.forEach(dmvFee => {
					if (dmvFee.feeID !== 7 && dmvFee.feeID !== 8 && dmvFee.feeID !== 4) {
						if (dmvFee.feeID === 1) {
							if (this.agencyConfig.agencyDmvConfig.mailFeeModel !== "NEVER") {
								if (
									this.agencyConfig.agencyDmvConfig.mailFeeModel === "ALWAYS"
								) {
									otherFees = otherFees + dmvFee.amount;
								} else if (
									this.agencyConfig.agencyDmvConfig.mailFeeModel ===
										"MAILONLY" &&
									this.dmvStoreService.registrationsInCart.mailingAddress
								) {
									otherFees = otherFees;
								}
							}
						} else {
							otherFees = otherFees + dmvFee.amount;
						}
					}
					if (dmvFee.feeID === 7 || dmvFee.feeID === 8 || dmvFee.feeID === 4) {
						plateStyleCost = plateStyleCost + dmvFee.amount;
					}
				});

				costAmount = costAmount + otherFees + plateStyleCost;
			}
			dmvRegistration.registration.renewalCost = renewalCost;
			dmvRegistration.registration.totalAmountDue = costAmount;
			const image = this.getImageCode(
				dmvRegistration.registration.currentTagCode
			);

			dmvRegistration.imageCode = image ? image.imageCode : null;
			dmvRegistration.altText = image ? image.name : null;

			dmvRegistration.oldImageCode = image ? image.imageCode : null;
			dmvRegistration.oldAltText = image ? image.name : null;
			dmvRegistration.oldPlateStyleCost = plateStyleCost;

			if (!this.dmvStoreService.registrationsInCart.dmvRegistrations) {
				this.dmvStoreService.registrationsInCart.dmvRegistrations = [];
				this.dmvStoreService.registrationsInCart.selectedRegistrations = [];
			}
			this.dmvStoreService.registrationsInCart.dmvRegistrations.push(
				dmvRegistration
			);
			this.dmvStoreService.registrationsInCart.selectedRegistrations.push(
				registration
			);
			this.dmvStoreService.registrationsInCart.dmvRegistrations = this.dmvStoreService.registrationsInCart.dmvRegistrations.slice();
		}
	}

	public getImageCode(currentTagCode) {
		AppUtil.log(
			"SearchResultsComponent getImageCode() ==> currentTagCode: ",
			currentTagCode
		);
		if (currentTagCode && this.tagCatalog) {
			const tags = this.tagCatalog.filter(function(item) {
				return item.tagCode === currentTagCode;
			});
			if (tags && tags.length > 0) {
				return tags[0];
			}
			AppUtil.log(
				"SearchResultsComponent getImageCode() ==> tagCatalog: ",
				tags
			);
		}
		AppUtil.log("SearchResultsComponent getImageCode() ==> tagCatalog: ", null);
		return null;
	}
	public formatedDate(dateStr) {
		if (dateStr && dateStr.indexOf("T") > 0) {
			return dateStr.substring(0, dateStr.indexOf("T"));
		} else {
			return dateStr;
		}
	}
	public goBack() {
		AppUtil.log("SearchResultsComponent goBack(): ");
		// if (
		// 	this.dmvStoreService.routeFrom &&
		// 	this.dmvStoreService.routeFrom.from === "dmv-review-cart"
		// ) {
		// 	this.router.navigate(["dmv-review-cart"]);
		// } else {
		// 	this.router.navigate(["dmv-search"]);
		// }
		this.router.navigate(["dmv-search"], { skipLocationChange: true });
	}

	public isExistInSearchResult() {
		if (this.registrations && this.registrations.length > 0) {
			return this.registrations.some(item => {
				return this.isInCart(item);
			});
		} else {
			return true;
		}
	}
	public continue() {
		AppUtil.log("SearchResultsComponent continue(): ");
		this.isPrivacy = true;
		if (this.qrCode || this.isExternalLint) {
			if (
				this.searchRegistrationForm &&
				this.searchRegistrationForm.controls &&
				this.searchRegistrationForm.controls.privacy &&
				!this.searchRegistrationForm.controls.privacy.value
			) {
				console.log("searchRegistrationForm.invalid");
				return;
			}
			if (
				this.searchRegistrationForm &&
				this.searchRegistrationForm.controls &&
				this.searchRegistrationForm.controls.privacy
			) {
				this.dmvStoreService.isPrivacyCheck = this.searchRegistrationForm.controls.privacy.value;
			}
		}

		if (
			this.dmvStoreService.registrationsInCart &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0 &&
			this.isExistInSearchResult()
		) {
			if (
				this.dmvStoreService.routeFrom &&
				this.dmvStoreService.routeFrom.from === "add-another"
			) {
				if (
					this.dmvStoreService.routeFrom.orderNumber ===
					this.dmvStoreService.registrationsInCart.dmvRegistrations.length
				) {
					this.router.navigate(["dmv-review-cart"], {
						skipLocationChange: true
					});
				} else {
					this.router.navigate(["dmv-customize-order"], {
						skipLocationChange: true
					});
				}
			} else {
				if (
					this.dmvStoreService.routeFrom &&
					this.dmvStoreService.routeFrom.orderNumber
				) {
					this.dmvStoreService.routeFrom.orderNumber = 0;
				}
				this.router.navigate(["dmv-customize-order"], {
					skipLocationChange: true
				});
			}
		} else {
			this.errorMessage =
				"Please add one or more registrations to your shopping cart";
			window.scrollTo(0, 0);
		}
	}
}
